import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { MagazinPage } from './pages/MagazinPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { CrescOfferPage } from './pages/CrescOfferPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { WorkshopPage } from './pages/WorkshopPage';
import { EvaluationPage } from './pages/EvaluationPage';
import { Course1Page } from './pages/Course1Page';
import { Course2Page } from './pages/Course2Page';
import { Course3Page } from './pages/Course3Page';
import { Course4Page } from './pages/Course4Page';
import { Course5Page } from './pages/Course5Page';
import { Course6Page } from './pages/Course6Page';
import { ConsultatiePunctualaPage } from './pages/ConsultatiePunctualaPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-brand-ivory font-source text-brand-text flex flex-col" data-id="element-2">
        <Header data-id="element-3" />
        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/magazin" element={<MagazinPage data-id="element-9" />} data-id="element-8" />
            <Route path="/despremine" element={<AboutPage data-id="element-11" />} data-id="element-10" />
            <Route path="/contact" element={<ContactPage data-id="element-13" />} data-id="element-12" />
            <Route path="/cresc" element={<CrescOfferPage data-id="element-15" />} data-id="element-14" />
            <Route path="/testimoniale" element={<TestimonialsPage data-id="element-17" />} data-id="element-16" />
            <Route path="/resursegratuite" element={<ResourcesPage data-id="element-19" />} data-id="element-18" />
            <Route path="/workshopgratuit" element={<WorkshopPage data-id="element-21" />} data-id="element-20" />
            <Route path="/evaluarecadou" element={<EvaluationPage data-id="element-23" />} data-id="element-22" />
            <Route path="/curscunoastereadezvoltarii" element={<Course1Page data-id="element-25" />} data-id="element-24" />
            <Route path="/cursrelationaresijoc" element={<Course2Page data-id="element-27" />} data-id="element-26" />
            <Route path="/cursemotiisireglare" element={<Course3Page data-id="element-29" />} data-id="element-28" />
            <Route path="/curss" element={<Course4Page data-id="element-31" />} data-id="element-30" />
            <Route path="/curscomportamentsiautonomie" element={<Course5Page data-id="element-33" />} data-id="element-32" />
            <Route path="/cursreevaluaresiurmatoriipasi" element={<Course6Page data-id="element-35" />} data-id="element-34" />
            <Route path="/consultatiepunctuala" element={<ConsultatiePunctualaPage data-id="element-37" />} data-id="element-36" />
          </Routes>
        </div>
        <Footer data-id="element-38" />
      </div>
    </BrowserRouter>;
}